import { Container, Column, Row, Align, Justify, Wrap } from '@uds/grid';
import { Block, Track } from '@uds/layout';
import { css, cx } from 'linaria';

import CheckoutButton from './CheckoutButton';
import { StickyCheckoutProps } from './types';
import StickyContainer from './StickyContainer';
import SearchInput from '../../SearchInput';
import { animateIn } from './StickyCheckout.stylesheet';

const checkoutBlock = css`
  text-align: end;
`;

export default function StickyCheckoutDesktop({
  basketCount,
  colorway,
  isSticky,
  ...rest
}: Readonly<StickyCheckoutProps>): JSX.Element {
  return (
    <StickyContainer isVisible={isSticky} isSticky={isSticky} colorway={colorway}>
      <Track>
        <Container>
          <Row wrap={Wrap.NOWRAP} align={Align.CENTER} justify={Justify.SPACE_BETWEEN}>
            <Column md={7}>
              <Block>
                <SearchInput {...rest} />
              </Block>
            </Column>
            {basketCount > 0 && (
              <Column>
                <Block className={cx(checkoutBlock, animateIn)}>
                  <CheckoutButton block={false} basketCount={basketCount} />
                </Block>
              </Column>
            )}
          </Row>
        </Container>
      </Track>
    </StickyContainer>
  );
}
